export default __webpack_public_path__ + "static/media/job_offer8_s.32dfe740.jpg";